import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../css/tabs.css'
import hotelcss from '../css/hotelhotellist.module.css';

import { getemployers,createEmployer, UpdateEmployer } from "../../dbconnector/connector";
import { useEffect } from 'react';

import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../../tools/errorhandling";
import Button from 'react-bootstrap/Button';

import EmployerNode from '../../customNodes/EmployerNode';
import moment, { now } from "moment";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


const createlist = (t, list, navigate) => {
    let divlist = document.getElementById("list")
    if (divlist === null) {
        let divlistheader = document.getElementById("resultlistHeader")
        const upperdiv = document.getElementById("searchbox");//resultlist
        const resultdiv = document.getElementById("resultlist")
        const newuserdiv = document.getElementById("newuser")

        divlist = document.createElement("div");
        divlist.id = "list"

        const zoekbalk = document.createElement("input");
        zoekbalk.type = "text"
        zoekbalk.id = "Zoekbalk"
        zoekbalk.placeholder = "Search"

        if (sessionStorage.getItem('employerZoek') !== null) {
            zoekbalk.value = sessionStorage.getItem('employerZoek')
        }

        const activelabel = document.createElement("label");
        activelabel.id = "activelabel"
        activelabel.className = "labelcolor"
        activelabel.innerText = t('Active')


        const active = document.createElement("input");
        active.type = "checkbox"
        active.className = "checkbox"
        if (sessionStorage.getItem('employerActive') !== null && sessionStorage.getItem('employerActive').toString() === "false") {
            active.checked = false
        } else {
            active.checked = true
        }
        active.label = "checkbox"

        if (sessionStorage.getItem('employerShowAll') !== null && sessionStorage.getItem('employerShowAll').toString() === "false") {
            active.disabled = false
        } else {
            active.disabled = true
        }

        active.id = "active"

        const ShowAlllabel = document.createElement("label");
        ShowAlllabel.id = "activelabel"
        ShowAlllabel.className = "labelcolor"
        ShowAlllabel.innerText = t('ShowAll')


        const showall = document.createElement("input");
        showall.type = "checkbox"
        showall.className = "checkbox"
        showall.id = "showall"
        if (sessionStorage.getItem('employerShowAll') !== null && sessionStorage.getItem('employerShowAll').toString() === "false") {
            showall.checked = false
        } else if (sessionStorage.getItem('employerShowAll') !== null && sessionStorage.getItem('employerShowAll').toString() === "true") {
            showall.checked = true
        } else { showall.checked = false }


        const addbutton = document.createElement("a");
        addbutton.id = "addbutton";
        addbutton.className = "btn btn-primary";
        addbutton.href = "/create-employer";
        addbutton.innerText = t('Nieuwewerkgever')

        active.addEventListener("click", function (e) {
            const zoekbalk = document.getElementById("Zoekbalk")
            sessionStorage.setItem('employerActive', active.checked)
            const filteredlist = list.filter(element => {
                if ((element.Naam).toLowerCase().includes(zoekbalk.value.toLowerCase()) || element.btw_nummer.includes(zoekbalk.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })

        showall.addEventListener("click", function (e) {
            active.disabled = showall.checked;
            sessionStorage.setItem('employerShowAll', showall.checked)
            const zoekbalk = document.getElementById("Zoekbalk")

            const filteredlist = list.filter(element => {
                if ((element.Naam).toLowerCase().includes(zoekbalk.value.toLowerCase()) || element.btw_nummer.includes(zoekbalk.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })

        zoekbalk.addEventListener("input", function (e) {
            if (sessionStorage.getItem('selectedemployer') !== null)
                sessionStorage.removeItem('selectedemployer')
            sessionStorage.setItem('employerZoek', e.target.value)

            const filteredlist = list.filter(element => {
                if ((element.Naam).toLowerCase().includes(e.target.value.toLowerCase()) || element.btw_nummer.includes(e.target.value.toLowerCase())) {
                    return element
                }
            })
            createlist(t, filteredlist, navigate)
        })
        upperdiv.appendChild(zoekbalk);
        upperdiv.appendChild(activelabel);
        upperdiv.appendChild(active);
        upperdiv.appendChild(ShowAlllabel);
        upperdiv.appendChild(showall);
        newuserdiv.appendChild(addbutton);
        resultdiv.appendChild(divlist);
    } else {
        divlist.innerHTML = "";
    }

    buildtable(list, divlist, navigate, t)

    try {
        if (sessionStorage.getItem('selectedemployer') !== null && document.getElementById("selector_" + sessionStorage.getItem('selectedemployer')) !== null) {
            document.getElementById("selector_" + sessionStorage.getItem('selectedemployer')).focus()
            document.getElementById("selector_" + sessionStorage.getItem('selectedemployer')).disabled = true;
        }
    }
    catch { }
}



const buildtable = (list, divlist, navigate, t) => {
    let filteredlist = list;

    if (sessionStorage.getItem('employerZoek') !== null) {
        filteredlist = list.filter(element => {
            if ((element.Naam).toLowerCase().includes(sessionStorage.getItem('employerZoek').toLowerCase()) || element.btw_nummer.includes(sessionStorage.getItem('employerZoek').toLowerCase())) {
                return element
            }
        })
    }
    if (document.getElementById("showall").checked === false) {
        filteredlist.filter(element => !document.getElementById("active").checked ? element.active === 0 : element.active === 1).forEach((element, index) => {
            addlinetogrid(divlist, element, index, navigate, t)
        });
    } else {
        filteredlist.forEach((element, index) => {
            addlinetogrid(divlist, element, index, navigate, t)
        });

    }
}

const addlinetogrid = (divlist, element, index, navigate, t) => {
    const employediv = document.createElement("div")
    divlist.appendChild(employediv)

    const selector = document.createElement("input");
    selector.className = "smallselector";
    selector.id = "selector_" + element.id
    

    const Id = document.createElement("p")
    Id.innerText = element.id
    employediv.appendChild(Id)

    const EMP_ID_div = document.createElement("p")
    EMP_ID_div.innerText = element.Naam
    employediv.appendChild(EMP_ID_div)

    // const name = document.createElement("p")
    // employediv.appendChild(name)
    // name.innerText = element.email

    const phone = document.createElement("p")
    phone.innerText = element.contactnumber
    employediv.appendChild(phone)

    const active = document.createElement("p")
    if (element.active === 0) {
        active.innerText = "false"
    } else {
        active.innerText = "true"

    }

    employediv.appendChild(active)


    if (sessionStorage.getItem('selectedemployer') === element.id.toString()) {
        employediv.className += hotelcss.hotelselectedRow
        employediv.appendChild(selector);
    } else {
        if (index % 2 === 0) {
            employediv.className = hotelcss.linkVarient1 //"linkVarient1 gridEmployees"
        } else {
            employediv.className = hotelcss.linkVarient2
        }
    }
    employediv.addEventListener('click', function (e) {
        sessionStorage.setItem('selectedemployer', element.id)
        navigate("/employer/" + element.id);
    });
}


const ConstructEmployerPage = (props) => {
    const [employerlist, setEmployerlist] = useState('');
    const navigate = useNavigate();
    const t = props.translation

    useEffect(() => {
        try {
            const employers = getemployers(true);
            employers.then((result) => {
                if (result.status === 200) {
                    setEmployerlist(result)
                    console.log(result)
                    createlist(props.translation, result.items, navigate)
                } else {
                    setErrorMessage(result.status + ": " + result.message)
                }

            })
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }
    }, []);


    return (
        <div id="main">
            <header>
                <div id="errordiv" className='error'>
                </div>
                <div className="checkinTime">
                    <div id="timelabel" >
                    </div>
                    <div id="time">
                    </div>
                </div>
            </header>
            <div id="newuser" className="form">
            </div>
            <div id="filters" className="form" >
                <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                <br></br>
                <div className="contentbox ">
                    <div id="searchbox" className="formElement">
                        <label className='labelcolor'>
                            {t('Werkgever')}:
                        </label>
                    </div>
                </div>
                <div id="headertable" className={hotelcss.tableheader}><p id="ID">{t('ID')}</p><p id="Fullname">{t('Name')}</p><p id="Phone">{t('Phone')}</p><p id="active">{t('Active')}</p></div>
                <div id="resultlist" className='list'>
                </div>
            </div>
        </div>
    )
}

const Addemployer = (props) => {
    const t = props.translation
    const [employer, setEmployer] = useState({});
    const navigate = useNavigate()
    const [tabsDisabled, setTabsDisabled] = useState(false);

    useEffect(() => {
        createEmptyEmployer()
        document.getElementById("editDiv").style.display = "none";
        setTabsDisabled(true);
    }, []);

    function formatDateToYYYYMMDD(date) {

        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day

            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }
    const createEmptyEmployer = () => {
        setEmployer((prev) => {
            return {
                ...prev,
                active: 1,
            }
        })

    }



    const changevalue = (e) => {
        setEmployer((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }
    const handleEdit = () => {
        // if (props.rights === 2) {
        //     setEdit(false)
        // } else if (props.rights === 4) {
        // }
        document.getElementById("editDiv").style.display = "none";
        document.getElementById("saveDiv").style.display = "grid";
    }
    const handleCancel = () => {
        //document.getElementById("coverAll").style.display= 'none'
        //LoadEmployer()
    }

    const onSubmit = (e) => {
        console.log("employer : ",employer)
        const response = UpdateEmployer({ ...employer }, null)
        response.then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    console.log("body", body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })

    }

    const navigateback = () => {
        navigate('/employers/employerlist')
    }

    return (
        <div id="main">
            <header><div id="errordiv" className='error'></div><div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div></header>
            <div id="coverAllmessage" className="coverall">
                <div id="messagediv" className='message'>
                    <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                        Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                    <br></br>
                    <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                </div>
            </div>
            <div id="return" className="form">
                <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={navigateback}>{t('Naaroverzicht')}</Button>
            </div>

            <EmployerNode
                rights={props.rights}
                translation={props.translation}
                isDisabled={false}
                data={{ employer: employer }}
                events={{ changevalue: changevalue, handleEdit: handleEdit, handleCancel: handleCancel, navigateback: navigateback, onSubmit: onSubmit }}
            />

        </div>
    )
}
export { ConstructEmployerPage, Addemployer }